import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import styled from "styled-components";
import TextLink from "./TextLink";

const PageHeading = ({ children, backUrl }) => {
  return (
    <Wrapper singleColumn={!backUrl}>
      {backUrl && (
        <div>
          <TextLink href={backUrl} color="white">
            <BackIcon icon={faChevronLeft} /> Back
          </TextLink>
        </div>
      )}
      <Heading>{children}</Heading>
    </Wrapper>
  );
};

const Wrapper = styled.div<{ singleColumn: boolean }>`
  display: grid;
  grid-template-columns: ${({ singleColumn }) =>
    singleColumn ? "auto" : "75px auto 75px"};
  align-items: center;
  background-color: ${({ theme }) => theme.colors.secondary};
  padding: 1rem 2rem;

  & ${TextLink} {
    font-size: 14px;
    font-weight: bold;
    color: white;
    box-shadow: 0px 0px 0px white;

    &:hover {
      color: white;
      box-shadow: 0px 2px 0px white;
    }
  }
`;

const BackIcon = styled(FontAwesomeIcon)`
  margin-right: 0.25rem;
`;

const Heading = styled.h1`
  padding: 0;
  margin: 0;
  color: white;
  font-size: 1.25rem;
  font-weight: 700;
  text-align: center;
`;

export default PageHeading;
